import { put, takeLatest, fetch, apply } from '@ers/helpers/redux/sagaEffects';

import ApiFactory from '@ers/api/ApiFactory';
import {
    ActionTypes,
    fetchSystemNotificationCompleted,
    updateSystemNotificationCompleted,
} from './Popup.actions';
import AppApi from '../App.api';


function* fetchSystemNotification(api) {
    const response = yield fetch(api, api.fetchSystemNotification);
    if (!response.error) {
        const actionCompleted = fetchSystemNotificationCompleted(response.data);
        yield put(actionCompleted);
    }
}

function* updateSystemNotification(api) {
    const response = yield fetch(api, api.updateSystemNotification);
    if (!response.error) {
        const actionCompleted = updateSystemNotificationCompleted(response.data);
        yield put(actionCompleted);
    }
}

export default function* popupSaga() {
    const apiFactory = new ApiFactory();
    const api = yield apply(apiFactory, apiFactory.create);
    const appApi = new AppApi(api);
    yield takeLatest(ActionTypes.fetchSystemNotification, fetchSystemNotification, appApi);
    yield takeLatest(ActionTypes.updateSystemNotification, updateSystemNotification, appApi);
}